import { forwardRef } from 'react';

import type { IconProps } from './types';

export const ChevronRight = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => (
    <svg
      width="8"
      height="8"
      viewBox="0 0 1024 1024"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <path
        d="M241.189 940.36c1.903 24.841 13.589 46.63 31.167 61.766l.119.099c15.703 13.533 36.298 21.775 58.819 21.775 27.432 0 52.01-12.228 68.577-31.534l.102-.121 361.319-421.538c13.527-15.7 21.764-36.293 21.764-58.807s-8.237-43.107-21.863-58.926l.099.119L399.973 31.655C383.304 12.231 358.729 0 331.294 0c-22.52 0-43.115 8.243-58.937 21.874l.119-.099c-19.345 16.663-31.519 41.19-31.519 68.563 0 22.574 8.282 43.214 21.97 59.05l-.096-.116 310.743 362.73-310.743 362.73c-13.603 15.723-21.888 36.369-21.888 58.951 0 2.351.09 4.68.265 6.984l-.02-.305z"
        fill={color}
      />
    </svg>
  )
);

export default ChevronRight;
